<script setup>
import { XMarkIcon } from "@heroicons/vue/24/solid";
import { useUndoToastStore } from "@/stores/UndoToastStore";

const toast = useUndoToastStore();
</script>

<template>
  <Transition
    enter-active-class="transition duration-200 ease-out"
    enter-from-class="translate-y-3 opacity-0"
    enter-to-class="translate-y-0 opacity-100"
    leave-active-class="transition duration-200 ease-in"
    leave-from-class="translate-y-0 opacity-100"
    leave-to-class="translate-y-3 opacity-0"
  >
    <div
      v-if="toast.visible"
      :key="toast.id"
      class="fixed bottom-5 left-1/2 z-[100] w-[calc(100%-2rem)] max-w-md -translate-x-1/2 overflow-hidden rounded-xl shadow-2xl"
      :class="
        toast.tone === 'error'
          ? 'bg-rose-700 text-white'
          : 'bg-slate-900 text-white dark:bg-slate-100 dark:text-slate-900'
      "
      :role="toast.tone === 'error' ? 'alert' : 'status'"
      aria-live="polite"
    >
      <div class="flex items-center gap-3 px-4 py-3">
        <span class="min-w-0 flex-1 text-sm font-medium">{{
          toast.message
        }}</span>
        <button
          v-if="toast.canUndo"
          type="button"
          class="shrink-0 rounded-md px-2 py-1 text-sm font-bold text-cyan-300 transition hover:bg-white/10 hover:text-cyan-200 disabled:cursor-wait disabled:opacity-60 dark:text-cyan-700 dark:hover:bg-slate-900/10"
          :disabled="toast.undoing"
          @click="toast.undo"
        >
          {{ toast.undoing ? "Undoing…" : "Undo" }}
        </button>
        <button
          type="button"
          class="shrink-0 rounded-md p-1 text-white/70 transition hover:bg-white/10 hover:text-white dark:text-slate-600 dark:hover:bg-slate-900/10 dark:hover:text-slate-900"
          aria-label="Dismiss notification"
          @click="toast.dismiss"
        >
          <XMarkIcon class="h-4 w-4" />
        </button>
      </div>
      <div
        :key="`progress-${toast.id}`"
        class="undo-toast-progress h-1 origin-left bg-cyan-400 dark:bg-cyan-600"
        :style="{ animationDuration: `${toast.duration}ms` }"
      ></div>
    </div>
  </Transition>
</template>

<style scoped>
@keyframes undo-toast-countdown {
  from {
    transform: scaleX(1);
  }
  to {
    transform: scaleX(0);
  }
}

.undo-toast-progress {
  animation-name: undo-toast-countdown;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
}
</style>
